import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {
  ModelePieceMarchePrix,
  ModeleRecherchePiece,
  modeleRecherchePieceValues,
} from '../../../components/Models'
import * as Yup from 'yup'
import {
  getPieceMarchePrix,
  getPieceOnMarket,
  getSearchPiece,
} from '../../../components/requests'
import {useFormik} from 'formik'
import {TextInput} from '../../../components/inputs/TextInput'
import {formatDate, shouldDisplayFonctionnalite} from '../../../components/helpers'
import {useAuth} from '../../modules/auth'
import {Tooltip} from 'react-tooltip'
import {PrixPieceMarcherModal} from './components/PrixPieceMarcherModal'

const recherchePieceSchema = Yup.object().shape({
  reference: Yup.string().notRequired(),
  referenceVehicule: Yup.string().notRequired(),
  nomenclatureTypePiece: Yup.string().notRequired(),
})

const RecherchePiecePage = () => {
  let {reference, referenceVehicule, nomenclatureTypePiece} = useParams()
  const [data, setData] = useState<ModeleRecherchePiece>(modeleRecherchePieceValues)
  const [resultData, setResultData] = useState<any | undefined>([])
  const [loading, setLoading] = useState(false)
  const [noExistingPiece, setNoExistingPiece] = useState(false)
  const {currentUser} = useAuth()
  const [onMarket, setOnMarket] = useState<any>([])
  const [dataPriceMarche, setDataPriceMarche] = useState<Array<ModelePieceMarchePrix>>([])

  const getPieceMarchePrixData = (refConst: string | number | undefined) => {
    getPieceMarchePrix(refConst).then((res) => {
      if (res?.status === 200 && res.data) {
        setDataPriceMarche(res.data)
      } else {
        console.log('error')
      }
    })
  }

  useEffect(() => {
    if (data?.reference || data?.referenceVehicule || data?.nomenclatureTypePiece) {
      setLoading(true)
      setNoExistingPiece(false)
      submitForm()
      getDataPieces(data.reference)
      getPieceMarchePrixData(data.reference)
    }
  }, [data])

  useEffect(() => {
    const updatedValues: Partial<ModeleRecherchePiece> = {}

    if (reference) {
      formik.setFieldValue('reference', reference)
      updatedValues.reference = reference
    }

    if (referenceVehicule) {
      formik.setFieldValue('referenceVehicule', referenceVehicule)
      updatedValues.referenceVehicule = referenceVehicule
    }

    if (nomenclatureTypePiece) {
      formik.setFieldValue('nomenclatureTypePiece', nomenclatureTypePiece)
      updatedValues.nomenclatureTypePiece = nomenclatureTypePiece
    }

    if (Object.keys(updatedValues).length > 0) {
      setData((prev) => ({...prev, ...updatedValues}))
    }
  }, [reference, referenceVehicule, nomenclatureTypePiece])

  const formik = useFormik<ModeleRecherchePiece>({
    initialValues: data,
    validationSchema: recherchePieceSchema,
    onSubmit: (values) => {
      setTimeout(() => {
        const updatedData = Object.assign({...data}, values)

        setData(updatedData)
      }, 200)
    },
  })

  const getDataPieces = async (refConst: string | undefined) => {
    try {
      const res = await getPieceOnMarket('', refConst)
      if (res && res.data) {
        // Tri par prix croissant
        const sorted = [...res.data].sort((a, b) => a.price - b.price)
        // Calcul des tiers
        const total = sorted.length
        const base = Math.floor(total / 3)
        const remainder = total % 3

        const groupSizes = [base + (remainder > 0 ? 1 : 0), base + (remainder > 1 ? 1 : 0), base]

        const onMarketData = sorted.map((item, index) => {
          let color: 'primary' | 'warning' | 'danger'

          if (index < groupSizes[0]) color = 'primary'
          else if (index < groupSizes[0] + groupSizes[1]) color = 'warning'
          else color = 'danger'

          return {...item, color}
        })
        setOnMarket(onMarketData)
      } else {
        // setNoExistingPiece(true)
      }
    } catch (error) {
      if (error instanceof Error && error.name !== 'AbortError') {
        console.log('Erreur!')
      }
    } finally {
      // setLoading(false)
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      getDataPieces(data?.reference ?? '')
    }, 5000)

    if (onMarket.length !== 0) {
      clearInterval(interval)
    }

    return () => clearInterval(interval)
  }, [onMarket])

  const submitForm = async (): Promise<void> => {
    setLoading(true)
    try {
      getSearchPiece(data.reference, data.referenceVehicule, data.nomenclatureTypePiece).then(
        (requestResponse) => {
          if (requestResponse?.status === 200) {
            if (requestResponse?.data !== undefined) {
              if (requestResponse?.data.success === false) {
                setNoExistingPiece(true)
              }
              setResultData(requestResponse?.data)
              setLoading(false)
            }
          }
        }
      )
    } catch (ex) {
      console.error(ex)
      setLoading(false)
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Recherche</h3>
          </div>
        </div>

        <div>
          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='card-body border-top p-9'>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  Référence constructeur
                </label>

                <div className='col-lg-8 fv-row'>
                  <TextInput
                    fieldName={'reference'}
                    inputPlaceholder={'Référence'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>Référence véhicule</label>

                <div className='col-lg-8 fv-row'>
                  <TextInput
                    fieldName={'referenceVehicule'}
                    inputPlaceholder={'Référence véhicule'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>Référence pièce</label>

                <div className='col-lg-8 fv-row'>
                  <TextInput
                    fieldName={'nomenclatureTypePiece'}
                    inputPlaceholder={'Référence pièce'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
            {shouldDisplayFonctionnalite(currentUser, 'RECHERCHER PIECES') && (
              <div className='card-footer d-flex justify-content-end py-6 px-9'>
                <button
                  type='submit'
                  className='btn btn-primary'
                  disabled={
                    loading ||
                    !!(
                      formik.values.nomenclatureTypePiece &&
                      formik.values.nomenclatureTypePiece.length < 6
                    )
                  }
                >
                  {!loading && 'Rechercher'}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Recherche...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            )}
          </form>
        </div>
      </div>

      {noExistingPiece && (
        <div>
          <div className='row g-5 g-xl-8'>
            {/* begin::Col  */}
            <div className='col-xxl-12'>
              <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
                <div className='card-body py-3'>
                  <p className={'text-danger mt-4'}>Aucune pièce trouvée avec cette référence</p>
                </div>
              </div>
            </div>
            {/* end::Col  */}
          </div>
        </div>
      )}

      {resultData?.success && (
        <div>
          <div className='row g-5 g-xl-8'>
            {/* begin::Col  */}
            <div className='col-xxl-12'>
              <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>Informations</span>
                  </h3>
                </div>
                {/* end::Header */}
                <div className='card-body py-3'>
                  {resultData?.piece && (
                    <div>
                      <p className='text-primary h6 mb-4'>
                        Pièce recherchée : {resultData?.piece?.typePiece?.nom}
                      </p>
                      <p>Véhicules compatibles : {resultData?.vehicules?.join(' | ')}</p>
                      {resultData?.piece?.prixConstructeur > 0 ? (
                        <div>
                          <p>
                            Prix constructeur : {resultData?.piece?.prixConstructeur.toFixed(2)}
                            &nbsp;€
                          </p>
                          {resultData?.piece?.prixConstructeurDate && (
                            <p>
                              Mise à jour du prix constructeur :{' '}
                              {formatDate(resultData?.piece?.prixConstructeurDate)}
                            </p>
                          )}
                          {resultData?.avgPrice && (
                            <div>
                              <p>
                                Prix moyen en vente par GSR : {resultData?.avgPrice.toFixed(2)}
                                &nbsp;€
                              </p>
                              <p>
                                Différence avec le prix constructeur : -
                                {(
                                  (1 - resultData?.avgPrice / resultData?.piece?.prixConstructeur) *
                                  100
                                ).toFixed(2)}
                                &nbsp;%
                              </p>
                            </div>
                          )}
                        </div>
                      ) : (
                        <p>Prix constructeur inconnu</p>
                      )}
                    </div>
                  )}
                  {resultData?.stock && (
                    <p className='text-success h6 mb-4'>
                      Pièces en stock : {resultData?.stock.length}
                    </p>
                  )}
                  {resultData?.nbResults && (
                    <p className='text-success h6 mb-4'>
                      Pièces sur le marché : {resultData?.nbResults}
                    </p>
                  )}
                </div>
              </div>
            </div>
            {/* end::Col  */}
          </div>

          <div className='row g-5 g-xl-8'>
            {/* begin::Col  */}
            <div className='col-xxl-12'>
              <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>Pièces en stock</span>
                  </h3>
                  <button
                    type='button'
                    className='btn btn-light-primary'
                    data-bs-target='#detailsPrixModal'
                    data-bs-toggle='modal'
                    data-bs-dismiss='modal'
                    data-tooltip-id='tooltip'
                    data-tooltip-content='Details du prix pièce marché'
                    data-tooltip-place='top'
                  >
                    Détails prix
                  </button>
                </div>
                {/* end::Header */}
                <div className='card-body py-3'>
                  {/* begin::Table container */}
                  <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      <thead>
                        <tr className='fw-bold text-muted'>
                          <th className='min-w-140px'>Code</th>
                          <th className='min-w-140px'>Commentaire</th>
                          <th className='min-w-140px'>Etat</th>
                          <th className='min-w-140px'>Prix € HT</th>
                          <th className='min-w-140px'>Livraison € HT</th>
                          <th className='min-w-140px'>Total € HT</th>
                        </tr>
                      </thead>
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {resultData?.stock?.map((piece, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                <p className={`text-dark d-block fs-6 mb-0`}>{piece.code}</p>
                              </td>
                              <td>
                                <p className={`text-dark d-block fs-6 mb-0`}>{piece.commentaire}</p>
                              </td>
                              <td>
                                <p className={`text-dark d-block fs-6 mb-0`}>
                                  {piece.etat?.libelle.toUpperCase()}
                                </p>
                              </td>
                              <td>
                                <p className={`text-dark d-block fs-6 mb-0`}>
                                  {piece.prix.toFixed(2)}&nbsp;€
                                </p>
                              </td>
                              <td>
                                <p className={`text-dark d-block fs-6 mb-0`}>
                                  {piece.prixTransport.toFixed(2)}&nbsp;€
                                </p>
                              </td>
                              <td>
                                <p className={`text-dark d-block fs-6 mb-0`}>
                                  {(piece.prix + piece.prixTransport).toFixed(2)}&nbsp;€
                                </p>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                  </div>
                  {/* end::Table container */}
                </div>
              </div>
            </div>
            {/* end::Col  */}
          </div>

          <div className='row g-5 g-xl-8'>
            {/* begin::Col  */}
            <div className='col-xxl-12'>
              <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>
                      Positionnement sur le marché
                    </span>
                  </h3>
                </div>
                {/* end::Header */}
                <div className='card-body py-3'>
                  {/* begin::Table container */}
                  <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      <thead>
                        <tr className='fw-bold text-muted'>
                          <th className=''></th>
                          <th className='min-w-140px'>N°</th>
                          <th className='min-w-140px'>Vendeur</th>
                          <th className='min-w-140px'>Prix € HT</th>
                          <th className='min-w-140px'>Livraison € HT</th>
                          <th className='min-w-140px'>Total € HT</th>
                        </tr>
                      </thead>
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {onMarket.length > 0 &&
                          onMarket?.map((piece, i) => {
                            return (
                              <tr
                                key={i}
                                // className={`table-${piece.color} ${piece.highlight ? "font-weight-bold" : ""}`}>
                                className={`table-${piece.color}`}
                              >
                                <td>
                                  <p
                                    // className={`text-dark ${piece.highlight ? "fw-bold" : ""} d-block fs-6 mb-0`}>
                                    className={`text-dark d-block fs-6 mb-0`}
                                  >
                                    {/*{piece.highlight &&*/}
                                    {/*  String.fromCharCode(10132)*/}
                                    {/*}*/}
                                  </p>
                                </td>
                                <td>
                                  <p
                                    // className={`text-dark ${piece.highlight ? "fw-bold" : ""} d-block fs-6 mb-0`}>
                                    className={`text-dark d-block fs-6 mb-0`}
                                  >
                                    {i + 1}
                                  </p>
                                </td>
                                <td>
                                  <p
                                    // className={`text-dark ${piece.highlight ? "fw-bold" : ""} d-block fs-6 mb-0`}>
                                    className={`text-dark d-block fs-6 mb-0`}
                                  >
                                    {piece.seller}
                                  </p>
                                </td>
                                <td>
                                  <p
                                    // className={`text-dark ${piece.highlight ? "fw-bold" : ""} d-block fs-6 mb-0`}>
                                    className={`text-dark d-block fs-6 mb-0`}
                                  >
                                    {(piece.price / 1.2).toFixed(2)}&nbsp;€
                                  </p>
                                </td>
                                <td>
                                  <p
                                    // className={`text-dark ${piece.highlight ? "fw-bold" : ""} d-block fs-6 mb-0`}>
                                    className={`text-dark d-block fs-6 mb-0`}
                                  >
                                    {(piece.shipping / 1.2).toFixed(2)}&nbsp;€
                                  </p>
                                </td>
                                <td>
                                  <p
                                    // className={`text-dark ${piece.highlight ? "fw-bold" : ""} d-block fs-6 mb-0`}>
                                    className={`text-dark d-block fs-6 mb-0`}
                                  >
                                    {((piece.shipping + piece.price) / 1.2).toFixed(2)}&nbsp;€
                                  </p>
                                </td>
                              </tr>
                            )
                          })}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                  </div>
                  {/* end::Table container */}
                </div>
              </div>
            </div>
            {/* end::Col  */}
          </div>

          {/*appel du modal detail du prix par rapport au reference constructeur*/}
          {onMarket && dataPriceMarche && <PrixPieceMarcherModal data={dataPriceMarche} />}

          {/*Affichage du tooltip*/}
          <Tooltip id='tooltip' />
        </div>
      )}
    </>
  )
}

export {RecherchePiecePage}
